const routes = [{
  path: '/assetinspection', // 资产巡检主页面
  name: 'assetinspection',
  component: () => import('@src/modules/account/main'),
  meta: {
    requireAuth: true
  },
  children: [
    {
      path: '/assetinspection/inspectionPlan',  //资产巡检主页面
      name: 'inspectionPlan',
      component: () => import('@src/modules/assetsPatrol/view/inspectionPlan'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    },
    {
      path: '/assetinspection/inspectionRecord',  //巡检记录主页面
      name: 'inspectionRecord',
      component: () => import('@src/modules/assetsPatrol/view/inspectionRecord'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    }, 
    {
      path: '/assetinspection/assetsConfig',//巡检参数配置
      name: 'assetsConfig',
      component: () => import('@src/modules/assetsPatrol/view/assetsConfig'),
      meta: {
        requireAuth: true,
        routerAlive: true
      }
    },
  ]

}]

export default routes
